__turbopack_context__.v({
  "bulletpoints": "amMXYq_bulletpoints",
  "caption": "amMXYq_caption",
  "fallbackButton": "amMXYq_fallbackButton",
  "headline": "amMXYq_headline",
  "loginForm": "amMXYq_loginForm",
  "prominent": "amMXYq_prominent",
  "screenset": "amMXYq_screenset",
  "text": "amMXYq_text",
});
